import { Fragment, PropsWithChildren, ReactNode, useEffect } from 'react'
import { Dialog, DialogPanel, DialogTitle, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'

export type FullScreenModalProps = {
  isOpen: boolean,
  onClose: () => void,
  title: string,
  header?: ReactNode
} & PropsWithChildren;

export default function FullScreenModal(props: FullScreenModalProps) {
  return (
    <Dialog as="div" className="relative z-[60]" open={props.isOpen} onClose={() => props.onClose()}>
      <div className="fixed inset-0" />

      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="pointer-events-none fixed top-0 bottom-0 right-0 left-0 flex max-w-full">
            <DialogPanel className="pointer-events-auto w-screen">
              <div className="flex h-full flex-col bg-slate-900 shadow-xl">
                <div className="px-4 sm:px-6 py-4 absolute inset-x-0 z-[60] bg-slate-900">
                  <div className="flex items-start justify-between">
                    <DialogTitle className="text-base font-semibold leading-6 text-white">
                      {props.title}
                    </DialogTitle>
                    <div className="ml-3 flex h-7 items-center">
                      <button
                        type="button"
                        className="relative rounded-md text-white hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                        onClick={() => props.onClose()}
                      >
                        <span className="absolute -inset-2.5" />
                        <span className="sr-only">Close panel</span>
                        <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className={`mt-[60px] flex-1 bg-secondary`}>
                  {props.children}
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </div>
    </Dialog>
  )
}
